import { AxiosRequestConfig } from "axios"
import AxiosContext from "../contexts/AxiosContext"
import { TrademarkBindingModel } from "../bindings/TrademarkBindingModel"

export const TrademarkService = {
    search: async (page: number = 0, model: TrademarkBindingModel.ISearchTrademarkBindingModel) => {
        try {
            const config: AxiosRequestConfig = {
                params: { pageIndex: page, ...model}
            }

            const { data, status } = await AxiosContext.get(`/trademarks`, config)
            return { data: data, status: status }
        } catch (error) {
            return { data: null, error: error }
        }
    },
}